"use strict";
exports.__esModule = true;
exports.chart_bar_data_stroke_Width = {
  "name": "--pf-chart-bar--data-stroke--Width",
  "value": 0,
  "var": "var(--pf-chart-bar--data-stroke--Width, 0)"
};
exports["default"] = exports.chart_bar_data_stroke_Width;